import React, { PureComponent } from 'react';

class TablaRowDatosAdicionales extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ajusteCargo } = this.props;

        let iva = ajusteCargo.DescripcionMoneda.toLocaleLowerCase() == "Pesos" ? "$" + ajusteCargo.ImporteIva : "u$s" + ajusteCargo.ImporteIva;
        let moneda = ajusteCargo.DescripcionMoneda;
        let usuario = ajusteCargo.UsuarioAlta;
        let cuotas = ajusteCargo.CantidadCuotas;
        let referencia = ajusteCargo.Referencia;
        let comprobante = ajusteCargo.NumeroReferencia;

        return (
            <tr className={"confirmadorAjusteCargoTableRowAdicionalBox"}>
                <div className="no-padding">
                    <div className={"confirmadorAjusteCargoTableRowAdicionalDivIzq"}>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowTop"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">IVA:</label>
                            <label className="col-md-7">{ajusteCargo.ImporteIva != undefined ? iva : "-"}</label>
                        </div>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowMiddle"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Moneda:</label>
                            <label className="col-md-7">{moneda ? moneda : "-"}</label>
                        </div>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowBottom"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Usuario:</label>
                            <label className="col-md-7">{usuario ? usuario : "-"}</label>
                        </div>
                    </div>

                    {/* Línea vertical divisoria */}
                    <div className="confirmadorAjusteCargoTableRowAdicionalLinea"></div>

                    <div className={"confirmadorAjusteCargoTableRowAdicionalDivDer"}>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowTop"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Cuotas</label>
                            <label className="col-md-7">{cuotas ? cuotas : "-"}</label>
                        </div>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowMiddle"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Referencia:</label>
                            <label className="col-md-7">{referencia ? referencia : "-"}</label>
                        </div>
                        <div className={"confirmadorAjusteCargoTableRowAdicionalRowBottom"}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Comprobante:</label>
                            <label className="col-md-7">{comprobante ? comprobante : "-"}</label>
                        </div>
                    </div>
                </div>
            </tr>);
    }
}

export default TablaRowDatosAdicionales;